package org.hs_soft.runmynesto.pages.components.dialog.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.util.helper.Strings

@Composable
fun SubmitButtons(
    arrangement: Arrangement.Horizontal,
    onCancelClick: () -> Unit,
    onSubmitClick: () -> Unit,
    isSubmitClickable: Boolean,
    loading:Boolean=false,
    windowSize: WindowSizeModeEnum,
    alignToRight:Boolean=true,
)
{
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .margin(top = Dimen.mediumPadding),
        horizontalArrangement = arrangement
    )
    {
        if (alignToRight)
            Spacer()

        CustomButton(
            modifier = Modifier
                .margin(
                    right = Dimen.mediumPadding
                ),
            windowSizeMode =windowSize,
            title = Strings.current().cancel,
            buttonType = ButtonTypes.TEXT,
            onButtonClick ={
                onCancelClick()
            },

        )

        CustomButton(
            windowSizeMode =windowSize,
            isClickable =isSubmitClickable,
            loading = loading,
            title = Strings.current().confirm,
            buttonType = ButtonTypes.CONTAINED,
            onButtonClick ={
                onSubmitClick()
            },
        )



    }
}